(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["intro-statement"] && !Shopify.designMode) return;
  try {
    
  /* Intro video: nothing is downloaded until the video is near the viewport, it
     pauses when scrolled away, and reduced-motion / Save-Data users get the poster only. */
  (function () {
    function init(v) {
      if (v.dataset.ready) return;
      v.dataset.ready = '1';
      v.muted = true;
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var saver = navigator.connection && navigator.connection.saveData;
      if (reduce || saver || !('IntersectionObserver' in window)) return;
      var loaded = false;
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              if (!loaded) {
                loaded = true;
                v.src = v.dataset.src;
                v.load();
              }
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else if (loaded) {
              v.pause();
            }
          });
        },
        { rootMargin: '200px 0px' }
      ).observe(v);
    }
    function scan() {
      document.querySelectorAll('video[data-lazy-video]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vadora-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReels(scope) {
      var frames = (scope || document).querySelectorAll('.vreel__frame[data-vreel]');
      frames.forEach(function (frame) {
        if (frame.dataset.vrBound) return;
        frame.dataset.vrBound = '1';
        var video = frame.querySelector('.vreel__video');
        var btn = frame.querySelector('.vreel__play');
        if (!video || !btn) return;

        btn.addEventListener('click', function () {
          var root = frame.closest('.vreels');
          if (root) {
            root.querySelectorAll('.vreel__video').forEach(function (other) {
              if (other !== video) {
                other.pause();
                var f = other.closest('.vreel__frame');
                if (f) f.classList.remove('is-playing');
              }
            });
          }
          video.setAttribute('controls', '');
          frame.classList.add('is-playing');
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        });

        // If a derived lighter rendition fails to load, step down the chain: 720p -> 480p -> original 1080p.
        video.addEventListener('error', function (e) {
          var s = e.target;
          if (!s || s.tagName !== 'SOURCE') return;
          var next = null;
          if (s.dataset.mid && s.src !== s.dataset.mid && s.src !== s.dataset.full) next = s.dataset.mid;
          else if (s.dataset.full && s.src !== s.dataset.full) next = s.dataset.full;
          if (!next) return;
          s.src = next;
          video.load();
          if (frame.classList.contains('is-playing')) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); }
        }, true);

        video.addEventListener('ended', function () {
          frame.classList.remove('is-playing');
          video.removeAttribute('controls');
          try { video.currentTime = 0; } catch (e) {}
        });
      });
    }

    // Warm up: once a strip is near the viewport, fetch only each video's first bytes (metadata)
    // so a tap starts almost instantly. Nothing heavy loads with the page itself.
    function warm() {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.querySelectorAll('.vreel__video').forEach(function (v) { v.preload = 'metadata'; });
          io.unobserve(en.target);
        });
      }, { rootMargin: '400px 0px' });
      document.querySelectorAll('.vreels').forEach(function (r) {
        if (!r.dataset.vrWarm) { r.dataset.vrWarm = '1'; io.observe(r); }
      });
    }

    if (document.readyState !== 'loading') {
      initReels(); warm();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initReels(); warm(); });
    }
    document.addEventListener('shopify:section:load', function (e) { initReels(e.target); warm(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
